export const ELIGIBLE_BUYERS_PER_PAGE = 10;
